<template>
    <div class="tableItemBlock">
        <q-item class="q-mx-lg">
            <slot>
                <!-- fallback content -->
            </slot>
        </q-item>
    </div>
</template>

<script>
export default {
    name: 'CTableItem',
    setup() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.tableItemBlock {
    height: 56px;
    padding-bottom: 8px;

    @media (max-width: $breakpoint-sm-max) {
        max-width: $breakpoint-xs-max;
        width: 100%;
        margin: 0 auto;
    }
}
.q-item {
    flex-wrap: wrap;
    background: white;
    padding: 0;
    @include border-radius(15px);
    @include box-shadow(0px 3px 5px 0px rgba($primary, 0.07), inset 0px 0px 0px 1px rgba($primary, 0.07));
    // @include box-shadow(0px 1px 3px 0px rgba($primary, 0.2), 0px 5px 10px 0px rgba($primary, 0.1), inset 0px 0px 0px 1px rgba($primary, 0.07));
    &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        transition: background-color 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), opacity 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);

        @include border-radius(15px);
    }

    &:not(.filter):hover {
        &::before {
            background-color: rgba($primary, 0.05);
        }
    }

    @media (max-width: $breakpoint-sm-max) {
        padding: 24px 0;
        margin: 0 16px;
    }

    .q-btn {
        .q-btn__content {
            flex-wrap: nowrap;
        }
    }

    :deep() .q-item__section {
        min-height: 48px;
        padding: 0 16px;
        color: $dark;
        // margin-left: 16px;
        // margin-right: 16px;
        position: relative;
        align-content: start;

        &.content-center {
            align-content: center;
        }

        &.content-end {
            align-content: end;
        }

        &:first-child {
            // margin-left: 24px;
            .enterBtn {
                // padding-left: 24px !important;
                @include border-radius(15px 0 0 15px);
            }
        }
        &:last-child {
            // margin-right: 24px;
            .enterBtn {
                // padding-right: 24px !important;
                @include border-radius(0 15px 15px 0);
            }
        }

        &.q-pa-none {
            padding: 0;
        }

        // &:has(> .enterBtn) {
        //     margin: 0px !important;
        // }

        .q-item__label {
            line-height: normal !important;

            &.inline {
                display: inline;
            }
        }
        .enterBtn {
            @include border-radius(0);
            padding: 8px 16px !important;

            &::before {
                content: '';
                position: absolute;
                box-sizing: content-box;
                background: rgba(0, 0, 0, 0.12);
                margin: 8px 0;
                flex-shrink: 0;
                width: 1px;
                height: calc(100% - 16px);
                align-self: stretch;
                @include border-radius(0px);
            }
        }

        // a:not(.q-btn) {
        //     text-decoration: none;
        //     color: $secondary;
        //     position: relative;

        //     &:hover {
        //         text-decoration: underline;
        //     }
        // }

        .q-badge {
            padding: 8px 0;
        }

        .q-checkbox {
            min-height: 48px;
            .q-checkbox__inner {
                opacity: 1 !important;
            }
        }

        .q-btn {
            padding: 8px 16px;
            &.q-px-lg {
                padding: 8px 24px;
            }
            &.q-px-none {
                padding: 8px;
            }
            &.borderTL {
                @include border-radius(15px 0px 0px 0px);
            }

            &.borderTR {
                @include border-radius(0px 15px 0px 0px);
            }

            &.borderBR {
                @include border-radius(0px 0px 15px 0px);
            }

            &.borderBL {
                @include border-radius(0px 0px 0px 15px);
            }

            &.borderTRBR {
                @include border-radius(0px 15px 15px 0px);
            }

            &.q-btn--flat {
                padding: 8px;
            }

            .block {
                margin-right: 8px;
            }
        }

        &.col1 {
            min-width: 200px !important;
            @media (max-width: $breakpoint-sm-max) {
                min-width: 0px !important;
            }
        }

        &.block {
            display: inherit !important;
        }

        &.q-item__section--avatar {
            min-width: auto;
        }

        @media (max-width: $breakpoint-sm-max) {
            flex-basis: 100%;
            padding: 0 24px 16px 24px;
            min-height: 0px;
            &::before {
                content: attr(data-label);
                font-weight: 600;
                font-size: em(16);
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                width: 100%;
                padding-right: 3px;
                display: initial;
            }
            &.block {
                display: inline !important;
                > * {
                    display: inline-flex;
                    width: auto !important;
                }
                &:before {
                    padding-right: 16px;
                }
            }

            &:last-child {
                padding-bottom: 0;
            }

            ~ .q-item__section--side {
                align-items: flex-start !important;
                align-content: flex-start !important;
            }

            .q-badge.highlighted {
                padding: 0;
                background: none !important;
            }
        }
    }
}
</style>
